var _g, _defs, _clipPath, _polygon, _g2, _defs2, _clipPath2, _polygon2, _defs3, _clipPath3, _polygon3, _defs4, _clipPath4, _polygon4, _g3, _defs5, _clipPath5, _polygon5, _defs6, _clipPath6, _polygon6, _defs7, _clipPath7, _polygon7, _defs8, _clipPath8, _polygon8, _defs9, _clipPath9, _polygon9, _defs10, _clipPath10, _polygon10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolcorel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "55.032px",
    viewBox: "0 0 40 55.032",
    enableBackground: "new 0 0 40 55.032",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2AC64B",
    d: "M1.965,18.569c-0.672-0.305-1.255-0.542-1.729-0.72c-0.101-0.747-0.172-1.495-0.219-2.245 c-0.036-0.618-0.014-1.229,0.06-1.829c0.404,0.065,0.976,0.167,1.688,0.305c-0.069,0.851-0.076,1.745,0,2.69 C1.813,17.373,1.88,17.975,1.965,18.569 M8.61,22.494c-1.7-1.246-3.296-2.213-4.683-2.954c-0.281-1.729-0.401-3.44-0.295-5.071 c1.282,0.284,2.797,0.65,4.466,1.113C7.988,17.762,8.193,20.106,8.61,22.494 M26.063,23.404c-0.015,0.188-0.038,0.378-0.058,0.568 c-2.323,1.213-4.631,2.847-6.71,5.051c-0.672,0.713-1.284,1.427-1.845,2.14c-0.627-0.793-1.298-1.599-2.011-2.409 c-0.319-0.36-0.638-0.713-0.96-1.053c-0.535-3.575-0.874-7.104-0.937-10.409C17.677,18.759,22.138,20.75,26.063,23.404 L26.063,23.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008A5A",
    d: "M2.473,10.606c-0.348,1.054-0.601,2.211-0.707,3.474c-0.712-0.138-1.285-0.239-1.688-0.305 c0.046-0.378,0.113-0.75,0.198-1.118C0.782,12.113,1.515,11.392,2.473,10.606"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009550",
    d: "M10.56,6.05c-1.223,2.242-2.203,5.262-2.449,9.294c-0.003,0.079-0.008,0.158-0.012,0.237 c-1.669-0.463-3.184-0.829-4.466-1.113c0.002-0.054,0.006-0.105,0.009-0.16c0.159-2.114,0.783-4.051,1.727-5.773 C6.828,7.634,8.556,6.759,10.56,6.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00983E",
    d: "M26.063,23.404c-3.926-2.654-8.387-4.646-12.52-6.112c-0.08-3.939,0.228-7.559,1.042-10.559 c0.022-0.082,0.044-0.164,0.068-0.245c3.277,1.937,7.548,4.096,11.603,5.046C26.611,15.11,26.504,19.173,26.063,23.404 L26.063,23.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009A37",
    d: "M39.982,15.604c-0.101,1.664-0.337,3.31-0.707,4.955c-0.469,0.018-1.007,0.047-1.604,0.1 c0.264-1.268,0.455-2.565,0.561-3.889c0.357-4.45-1.081-7.841-2.744-10.207c0.487,0.14,0.948,0.275,1.38,0.408 C38.737,9.339,40.179,12.382,39.982,15.604 M35.828,20.875c-1.304,0.187-2.774,0.478-4.324,0.92c0.356-2.234,0.51-4.414,0.385-6.45 c-0.283-4.643-1.539-7.942-3.018-10.261c1.391,0.229,2.709,0.5,3.926,0.785c1.939,2.293,3.313,5.153,3.56,8.442 C36.514,16.405,36.288,18.639,35.828,20.875"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00863F",
    d: "M26.257,11.535c-4.055-0.95-8.326-3.109-11.603-5.046c0.173-0.6,0.367-1.146,0.58-1.641 c0.6-0.102,1.219-0.187,1.855-0.251c2.561-0.26,5.117-0.236,7.553-0.036c0.286,0.635,0.55,1.355,0.772,2.173 C25.812,8.198,26.089,9.81,26.257,11.535"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06CBF6",
    d: "M8.753,2.398c-0.135,0.083-4.49,2.764-6.28,8.207c-0.958,0.786-1.69,1.508-2.196,2.052 C1.461,7.522,6.188,3.328,8.753,2.398 M11.509,4.517c-0.327,0.466-0.646,0.975-0.95,1.534C8.556,6.759,6.828,7.634,5.37,8.535 C6.484,6.487,8.052,4.744,9.82,3.36C10.24,3.66,10.813,4.057,11.509,4.517z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M35.488,6.563c0.487,0.14,0.948,0.275,1.38,0.408c-1.845-2.343-4.112-4.029-5.625-4.575 C31.243,2.396,33.523,3.766,35.488,6.563 M9.82,3.36c0.42,0.299,0.994,0.697,1.688,1.156c2.422-3.459,5.257-4.464,5.402-4.515 C14.553,0.474,12.03,1.634,9.82,3.36 M28.871,5.083c1.39,0.229,2.709,0.5,3.926,0.785c-2.646-3.123-6.348-5.194-9.707-5.867 C23.241,0.054,26.375,1.167,28.871,5.083 M19.958,0c0,0-2.926,0.607-4.725,4.848c0.6-0.103,1.219-0.187,1.855-0.251 c2.561-0.26,5.117-0.236,7.553-0.036c-1.806-3.982-4.6-4.56-4.6-4.56H19.958z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.4434,
    y1: -702.9385,
    x2: -3.3442,
    y2: -702.9385,
    gradientTransform: "matrix(245.0597 7.4265 7.4265 -245.0597 6075.2207 -172233.2031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0288F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2EE2BD"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "url(#SVGID_3_)",
    points: "9.609,6.965 36.844,7.791 37.08,0.006 9.845,-0.819  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#666565",
    points: "20,55.032 23.007,55.032 24.119,50.177 15.879,50.177 16.992,55.032  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M8.64,33.296c0.579,1.197,1.131,2.265,1.606,3.156c0.815,1.525,1.589,2.821,2.388,4.002 c0.231-0.809,0.52-1.662,0.879-2.546c-0.62-1.422-1.243-2.95-1.834-4.541c-1.287-3.459-2.429-7.22-3.068-10.873 c-1.7-1.246-3.296-2.213-4.684-2.954C4.723,24.457,6.812,29.521,8.64,33.296"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.6245,
    y1: -701.354,
    x2: -3.5255,
    y2: -701.354,
    gradientTransform: "matrix(-60.2805 -149.0676 -149.0676 60.2805 -104755.3906 41776.5625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB1918"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#A2183D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    style: {
      stopColor: "#902869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73358A"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_5_)",
    fill: "url(#SVGID_6_)",
    points: "20.782,37.515 12.166,16.208 -3.341,22.48 5.275,43.786  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M5.922,33.234c0.328,0.573,0.668,1.146,1.021,1.728c1.652,2.708,3.56,5.209,5.258,7.241 c0.049-0.248,0.107-0.502,0.172-0.759c-0.687-0.944-1.357-1.903-1.934-2.793c-0.826-1.271-2.023-3.116-3.269-5.387 c-2.136-3.895-4.416-9.04-5.207-14.695c-0.672-0.305-1.254-0.541-1.729-0.72C0.919,22.921,2.857,27.896,5.922,33.234"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.625,
    y1: -701.5444,
    x2: -3.5259,
    y2: -701.5444,
    gradientTransform: "matrix(-60.2818 -149.0689 -149.0689 60.2818 -104786.7344 41789.7773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB1918"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#A2183D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    style: {
      stopColor: "#902869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73358A"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_8_)",
    fill: "url(#SVGID_9_)",
    points: "20.838,38.78 10.668,13.632 -8.228,21.272 1.942,46.421  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M14.778,29.587c0.215,1.281,0.466,2.582,0.737,3.867c0.026,0.122,0.052,0.244,0.079,0.366 c0.542-0.878,1.158-1.767,1.857-2.657c-0.648-0.82-1.319-1.624-2.011-2.409c-0.318-0.36-0.638-0.713-0.96-1.053 C14.574,28.33,14.671,28.958,14.778,29.587"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.6255,
    y1: -701.0376,
    x2: -3.5259,
    y2: -701.0376,
    gradientTransform: "matrix(-60.2818 -149.069 -149.069 60.2818 -104703.1094 41755.9023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB1918"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#A2183D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    style: {
      stopColor: "#902869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73358A"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_11_)",
    fill: "url(#SVGID_12_)",
    points: "19.579,32.961 17.034,26.669 12.353,28.562 14.897,34.854  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#97CC1A",
    d: "M37.672,20.659c-0.765,3.715-2.114,7.156-3.546,10.099c0.29,0.292,0.571,0.582,0.846,0.869 c2.042-3.796,3.494-7.429,4.304-11.067C38.807,20.578,38.269,20.606,37.672,20.659 M31.504,21.795 c-0.279,1.774-0.685,3.582-1.174,5.372c0.844,0.761,1.768,1.614,2.677,2.49c1.136-2.711,2.196-5.749,2.822-8.782 C34.524,21.062,33.055,21.353,31.504,21.795"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M33.962,31.094c-1.623,3.271-3.326,5.899-4.403,7.558c-1.242,1.913-2.917,4.154-4.243,5.872 c0.048,0.126,0.094,0.245,0.138,0.357c2.056-2.239,5.119-5.846,7.602-9.919c0.623-1.02,1.206-2.028,1.75-3.025 c0.056-0.104,0.111-0.206,0.167-0.31c-0.274-0.287-0.556-0.577-0.846-0.869C34.07,30.872,34.016,30.982,33.962,31.094  M30.266,27.4c-1.573,5.684-3.972,11.194-5.87,14.989c0.207,0.451,0.394,0.87,0.559,1.256c1.753-2.086,3.198-4.197,4.799-7.193 c0.881-1.649,2.023-3.896,3.11-6.456l0.144-0.339c-0.909-0.876-1.833-1.729-2.677-2.49L30.266,27.4z M19.296,29.023 c-0.672,0.713-1.284,1.427-1.845,2.14c2.443,3.087,4.26,6.021,5.575,8.477c0.478-1.847,0.973-3.891,1.417-5.984 c0.286-1.351,0.552-2.72,0.777-4.068c0.317-1.882,0.584-3.762,0.785-5.612C23.683,25.186,21.375,26.819,19.296,29.023"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.8979,
    y1: -701.8379,
    x2: -1.799,
    y2: -701.8379,
    gradientTransform: "matrix(-87.4781 95.5526 95.5526 87.4781 66927.5391 61605.8164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADD816"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBD704"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_14_)",
    fill: "url(#SVGID_15_)",
    points: "25.44,15.247 7.039,35.348 26.983,53.606 45.385,33.507  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_16_",
    d: "M21.582,47.337c1.28-1.328,2.378-2.506,3.372-3.691c-0.165-0.386-0.352-0.805-0.559-1.256 C23.051,45.08,21.956,46.909,21.582,47.337"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.8516,
    y1: -700.9814,
    x2: -2.7524,
    y2: -700.9814,
    gradientTransform: "matrix(-74.4659 -125.578 -125.578 74.4659 -88216.1406 51887.3672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1282B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3402A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    style: {
      stopColor: "#E76226"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F19A0A"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_17_)",
    fill: "url(#SVGID_18_)",
    points: "27.125,46.05 24.077,40.91 19.412,43.677 22.46,48.816  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M23.155,47.259c0.066-0.066,0.974-0.939,2.298-2.378c-0.044-0.112-0.09-0.231-0.138-0.357 C24.129,46.06,23.225,47.175,23.155,47.259"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.8506,
    y1: -700.9463,
    x2: -2.7506,
    y2: -700.9463,
    gradientTransform: "matrix(-74.4656 -125.578 -125.578 74.4656 -88211.3359 51884.4063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1282B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3402A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    style: {
      stopColor: "#E76226"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F19A0A"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_20_)",
    fill: "url(#SVGID_21_)",
    points: "26.654,46.547 24.856,43.514 21.954,45.235 23.752,48.268  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_22_",
    d: "M15.594,33.82c1.513,7.078,3.588,13.572,3.588,13.572h1.636c0,0,1.054-3.297,2.208-7.753 c-1.315-2.455-3.132-5.39-5.575-8.477C16.752,32.054,16.135,32.942,15.594,33.82"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_23_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_22_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.8506,
    y1: -701.0405,
    x2: -2.7517,
    y2: -701.0405,
    gradientTransform: "matrix(-74.4659 -125.578 -125.578 74.4659 -88224.0156 51892.1172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1282B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3402A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    style: {
      stopColor: "#E76226"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F19A0A"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_23_)",
    fill: "url(#SVGID_24_)",
    points: "30.146,43.171 21.092,27.903 8.473,35.386 17.526,50.654  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M12.634,40.454c1.655,2.457,3.398,4.409,5.783,6.883c-0.556-0.637-2.708-4.375-4.904-9.429 C13.154,38.792,12.865,39.646,12.634,40.454"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.8506,
    y1: -701.333,
    x2: -2.7517,
    y2: -701.333,
    gradientTransform: "matrix(-74.4659 -125.578 -125.578 74.4659 -88265.0156 51916.4922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1282B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3402A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    style: {
      stopColor: "#E76226"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F19A0A"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_26_)",
    fill: "url(#SVGID_27_)",
    points: "22.554,44.885 16.913,35.372 8.499,40.36 14.139,49.874  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_28_",
    d: "M12.202,42.203L12.202,42.203c2.496,2.989,4.542,4.956,4.646,5.056c-0.11-0.137-2.365-2.906-4.474-5.814 C12.309,41.701,12.251,41.955,12.202,42.203"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_29_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_28_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.8511,
    y1: -701.4316,
    x2: -2.7516,
    y2: -701.4316,
    gradientTransform: "matrix(-74.4659 -125.5793 -125.5793 74.4659 -88279.7344 51924.582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1282B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#E3402A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    style: {
      stopColor: "#E76226"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F19A0A"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_29_)",
    fill: "url(#SVGID_30_)",
    points: "19.399,45.746 15.639,39.406 9.65,42.957 13.41,49.298  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolcorel);
export default __webpack_public_path__ + "static/media/toolcorel.495896984b4582d25f6dc77c8211f8a9.svg";
export { ForwardRef as ReactComponent };